import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';
import { AngularFireAuth } from 'angularfire2/auth';
import { AngularFireDatabase, FirebaseListObservable } from "angularfire2/database-deprecated";
import { Router } from '@angular/router';

import { AuthService } from '../services/AuthService'
import { BuyService } from '../services/buyservice'

@Injectable()
export class SearchItemService {

    TextSearch = 'Jame';
    constructor(public afAuth: AngularFireAuth, public router: Router, private afdb: AngularFireDatabase, public auth: AuthService, public buy: BuyService) {

    }
    
   

}


// WEBPACK FOOTER //
// D:/pokpak-v3/pokpak-v2/pokpak-ang/src/app/services/searchService.ts